import React, {useEffect, useState} from "react";
import classnames from "classnames";
import ClayIcon from '@clayui/icon';
import ClaySticker from '@clayui/sticker';
import './mini_compare.scss';


const ITEM_REMOVED_FROM_COMPARE="item-removed-from-compare";
const TOGGLE_ITEM_IN_PRODUCT_COMPARISON="toggle-item-in-compare";
const ITEMS_LIMIT = 3;

function Item(props) {
    return (
        <div className={classnames('mini-compare-item', props.id && 'active')}>
            <ClaySticker className="mini-compare-thumbnail-container" size="lg">
                <div
                    className="mini-compare-thumbnail"
                    style={
                        props.thumbnail
                            ? {backgroundImage: `url('${props.thumbnail}')`}
                            : {}
                    }
                />
            </ClaySticker>

            <button className="mini-compare-delete" onClick={props.onDelete}>
                <ClayIcon symbol="times" spritemap={Liferay.ThemeDisplay.getPathThemeImages() + "/clay/icons.svg"}/>
            </button>
        </div>
    );
}

const MiniCompare = () => {
    const [items, setItems] = useState([]);


    useEffect(() => {
        function toggleItem({id, thumbnail}) {
            const newItem = {
                id,
                thumbnail,
            };

            setItems((items) => {
                const included = items.find((element) => element.id === id);

                return included
                    ? items.filter((i) => i.id !== id)
                    : items.concat(newItem);
            });
        }

        Liferay.on(TOGGLE_ITEM_IN_PRODUCT_COMPARISON, toggleItem);

        return () => {
            Liferay.detach(TOGGLE_ITEM_IN_PRODUCT_COMPARISON, toggleItem);
        };
    }, []);

    const generateUrl = () => {
        const damageReportReferenceNumber = document.querySelector("input[name=damageReportReferenceNumber]")?.value;
        const miniCompareElement = document.querySelector("up2date-mini-compare");
        let baseUrl = "/compare";
        if(miniCompareElement && miniCompareElement.getAttribute("compare-page")) {
            baseUrl = miniCompareElement.getAttribute("compare-page");
        }
        const queryParams = items.length ? `?ids=${items.map(item => item.id).join(',')}` : '';
        const redirectParam = "&redirect=" + window.location.href
        const damageReportReferenceNumberParam = damageReportReferenceNumber ? "&damageReportReferenceNumber=" + damageReportReferenceNumber : "";
        return `${baseUrl}${queryParams}${redirectParam}${damageReportReferenceNumberParam}`;

    };

    return (
        <div className={classnames('mini-compare', !!items.length && 'active')}>
            {Array(ITEMS_LIMIT)
                .fill(null)
                .map((_el, i) => {
                    const currentItem = items[i] || {};

                    return (
                        <Item
                            {...currentItem}
                            key={i}
                            onDelete={(event) => {
                                event.preventDefault();
                                setItems(
                                    items.filter((v) => v.id !== currentItem.id)
                                );
                                Liferay.fire(
                                    ITEM_REMOVED_FROM_COMPARE,
                                    currentItem
                                );
                            }}
                        />
                    );
                })}

            <a className="btn btn-primary" href={generateUrl()}>
                {Liferay.Language.get('compare')}
            </a>
        </div>
    )
}

export default MiniCompare;